<template>
  <div class="heading1">
    <h1>{{ text }}</h1>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default() {
        return 'Heading1';
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/colors';

.heading1 {
  margin-bottom: 2rem;

  display: flex;
  align-items: center;

  h1 {
    font-size: 2rem;
    margin-right: 1rem;
    margin-bottom: 0;
    color: $darkBlue;
  }

  ::v-deep.right-side {
    margin-left: auto;
  }
}
</style>
